module.exports = __webpack_public_path__ + "img/icon_5.f4514b3d.svg";